import WirelineDepartmentsTabsContent from './WirelineDepartmentsTabsContent';

export default WirelineDepartmentsTabsContent;
